import quote from "../img/quote.png";
import "../css/testimonials.css";
function Testimonials(props) {
  return (
    <>
      <div className=" testimonials">
        <div className="imagen"><img src={props.src}></img></div>
        <div>
            <img className="quote-icon" src={quote}></img>
            {props.content}
        </div>
      </div>
    </>
  );
}

export default Testimonials;
